import { Component, OnInit } from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';

import { ClozeTestStyleModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-style-model';
import { ActivatedRoute } from '@angular/router';

import { ClozeTestModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-model';
import { UrlParametersModel } from 'gast-onset-ng/lib/cloze-test/model/url-parameters-model';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.css']
})
export class DemoComponent implements OnInit {

  cTestLogo: string;
  cTestButtonColor: string;
  mobileMode: boolean;

  isStarted = false;
  validToken = false;
  isLoading = false;

  // onset param
  gastBookingId: number;
  startLevel = 2;
  endLevel = 5;
  variantId = 11;
  language = 1; // default DE
  lang = 'de';

  clozeTestModel: ClozeTestModel;
  clozeTestStyleModel: ClozeTestStyleModel;

  constructor(
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    // detect mobile
    this.mobileMode = this.deviceService.isMobile();
    console.log('is mobile device: ' + this.mobileMode);

    // generate style
    this.clozeTestStyleModel = this.generateClozeTestStyle();

    // sett logo and button color
    this.cTestLogo = 'onset-assets/img/onset_logo.png';
    this.cTestButtonColor = this.clozeTestStyleModel.onsetColor;

    // callback for query parameter
    this.route.queryParams.subscribe(params => {
      this.isLoading = true;
      if (params['token']) {
        const token = params['token'] as string;
        if (token === 'DEMO-91034f05-f5b9-459e-a5d1-03db1215eb59') {
          this.validToken = true;
        }
      }
      if (params['lang'] === 'en') {
        this.language = 2;
        this.lang = 'en';
      }
      this.isLoading = false;
    });
  }

  startOnset(): void {
    this.clozeTestModel = this.generateClozeTestModel();
    this.clozeTestStyleModel = this.generateClozeTestStyle();
    this.isStarted = true;
  }

  public onStartTest(start: boolean): void {
    console.log(`test started`);
  }

  public onBookingInit(gastBookingId: number): void {
    this.gastBookingId = gastBookingId;
    console.log(`init gastBookingId ${gastBookingId}`);
  }

  public onTestHasBeenSaved(gastBookingId: number): void {
    this.gastBookingId = gastBookingId;
    console.log(`saving gastBookingId ${gastBookingId}`);
  }

  public onClozeTestCompleted(): void {
    console.log(`test completed`);
  }

  public onTestResult(test: any): void {
    console.log(`next test result ${test}`);
  }

  private generateClozeTestModel(): ClozeTestModel {
    const onsetServiceUrl = 'https://apprex.gast.de/gast-service-onset/';

    const clozeTestModel: ClozeTestModel = {} as ClozeTestModel;
    clozeTestModel.getResultsUrl = onsetServiceUrl + 'api/score';
    clozeTestModel.postTestUrl = onsetServiceUrl + 'api/aufgabe/save';
    clozeTestModel.getTestUrl = onsetServiceUrl + 'api/aufgabe';
    clozeTestModel.getNextTestUrl = onsetServiceUrl + 'api/aufgabe/next';
    clozeTestModel.startWithBuchungId = this.gastBookingId;
    clozeTestModel.urlParameters = {
      herkunft: 'deutschland',
      geschlecht: 'm',
      geburtsdatum: '1990-01-01',
      variante: this.variantId,
      testzentrum: 454,
      sprache: this.language,
      tool: 1,
      start_level: this.startLevel,
      end_level: this.endLevel
    } as UrlParametersModel;
    return clozeTestModel;
  }

  private generateClozeTestStyle(): ClozeTestStyleModel {
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;

    if (this.lang === 'de') {
      model.cTestInformationUrl = 'https://de.wikipedia.org/wiki/Gemeinsamer_europ%C3%A4ischer_Referenzrahmen_f%C3%BCr_Sprachen';
    } else if (this.lang === 'en') {
      model.cTestInformationUrl = 'https://en.wikipedia.org/wiki/Common_European_Framework_of_Reference_for_Languages';
    } else {
      model.cTestInformationUrl = 'https://en.wikipedia.org/wiki/Common_European_Framework_of_Reference_for_Languages';
    }

    return model;
  }
}
